import { OrganizationContext } from '@/pages/Organizations/Item'
import { createOrganizationMemberGroup, getOrganizationMembers } from '@/services/member/member'
import { ModalForm } from '@ant-design/pro-form'
import { useRequest } from 'ahooks'
import { Form, Input, Select } from 'antd'
import React, { memo, useContext } from 'react'

interface AddGroupProps {
  trigger: JSX.Element
  onSuccess?: () => void
}

export default memo<AddGroupProps>(function AddGroup(props) {
  const [form] = Form.useForm()
  const { trigger, onSuccess, ...other } = props
  const orgData = useContext(OrganizationContext).orgData!
  const { data: members = [] } = useRequest(() => getOrganizationMembers(orgData.id))
  const { run } = useRequest(createOrganizationMemberGroup, {
    manual: true,
    onSuccess
  })

  return (
    <ModalForm
      {...other}
      form={form}
      trigger={trigger}
      width={500}
      title='New group'
      modalProps={{
        maskClosable: false
      }}
      onVisibleChange={(visible: boolean) => {
        visible && form.resetFields()
      }}
      onFinish={async (values) => {
        run(orgData.id, values)
        return true
      }}
    >
      <Form.Item label='Group name' name='name'>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Member’s' name='memberIds'>
        <Select mode={'multiple'} showSearch>
          {members.map((member) => (
            <Select.Option key={member.memberId} value={member.memberId}>
              {member.fullName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </ModalForm>
  )
})
